import React from "react";
import Content from "../components/elements/Content";
import PageWrapper from "../components/elements/PageWrapper";

const SteeringCommittee = () => {
    return (
        <PageWrapper>
            <Content>
                <h1>Technical Program Committee</h1>
                <hr />
                <table>
                    <tbody>
                        <tr><td>Aditya Devarakonda, Wake Forest University, USA</td></tr>
                        <tr><td>Alex Delis, Univ. of Athens, Greece</td></tr>
                        <tr><td>Alex Sim, Lawrence Berkeley National Laboratory, USA</td></tr>
                        <tr><td>Alexandre da Silva Veith, Nokia Bell Labs</td></tr>
                        <tr><td>Alexandru Costan, Research Institute Computer And Systems Aléatoires, France</td></tr>
                        <tr><td>Alfredo Goldman, USP, Brazil</td></tr>
                        <tr><td>Ali	Khoshkholghi, Middlesex University London, UK</td></tr>
                        <tr><td>André Bauer, University of Würzburg, Germany</td></tr>
                        <tr><td>Anirban Mandal, RENCI</td></tr>
                        <tr><td>Antonio Brogi, University of Pisa, Italy</td></tr>
                        <tr><td>Atakan Aral, University of Vienna, Austria</td></tr>
                        <tr><td>Attila Kertesz, University of Szeged, Hungary</td></tr>
                        <tr><td>Auday Al-Dulaimy, Mälardalen University, Sweden</td></tr>
                        <tr><td>Balazs Gerofi, Intel Corporation</td></tr>
                        <tr><td>Beilei Jiang, University of North Texas, USA</td></tr>
                        <tr><td>Carlos Guerrero, University of the Balearic Islands, Spain</td></tr>
                        <tr><td>Cristina Abad, Escuela Superior Politecnica del Litoral, Ecuador</td></tr>
                        <tr><td>Dalibor Klusacek, CESNET, Czech Republic</td></tr>
                        <tr><td>Daniel Balouek, Inria, France</td></tr>
                        <tr><td>Daniel Grosu, Wayne State University, USA</td></tr>
                        <tr><td>David Bermbach, Technische Universität Berlin, Germany</td></tr>
                        <tr><td>Demetris Trihinas, University of Nicosia, Cyprus</td></tr>
                        <tr><td>Dong Dai, UNC-Charlotte, USA</td></tr>
                        <tr><td>Dr. Chandrashekar Jatothu, National Institute of Technology Raipur, India</td></tr>
                        <tr><td>Dr. Satya Prakash Yadav, GL Bajaj Institute of Technology and Management, India</td></tr>
                        <tr><td>Felix Freitag, Technical University of Catalonia, Spain</td></tr>
                        <tr><td>Francisco Brasileiro, UFCG, Brazil</td></tr>
                        <tr><td>George Pallis, University of Cyprus, Cyprus</td></tr>
                        <tr><td>Habeeb Olufowobi, University of Texas at Arlington, USA</td></tr>
                        <tr><td>Hameed Badawy, New Mexico State University, USA</td></tr>
                        <tr><td>Harshit Gupta, Microsoft</td></tr>
                        <tr><td>Heeralal Dr.M, National Institute of Technology, Warangal, India</td></tr>
                        <tr><td>In Kee Kim, University of Georgia, Georgia</td></tr>
                        <tr><td>Ivan Rodero, University of Utah, USA</td></tr>
                        <tr><td>Javier Garcia-Blas, University Carlos III of Madrid, Spain</td></tr>
                        <tr><td>Jean Luca Bez, Lawrence Berkeley National Laboratory, USA</td></tr>
                        <tr><td>Jean-Baptiste Besnard, ParaTools SAS, France</td></tr>
                        <tr><td>Jia Rao, University of Texas at Arlington, USA</td></tr>
                        <tr><td>Joel Coffman, United States Air Force Academy, USA</td></tr>
                        <tr><td>Juan José Durillo, Leibniz Supercomputing Centre, Germany</td></tr>
                        <tr><td>Katerina Doka, National Technical University of Athens, Greece</td></tr>
                        <tr><td>Kenichi Kourai, Kyushu Institute of Technology, Japan</td></tr>
                        <tr><td>Kirill Morozov, University of North Texas, USA</td></tr>
                        <tr><td>Kyungyong Lee, Kookmin University, South Corea</td></tr>
                        <tr><td>Lawrence Chung, Erik Johnson School of Engineering and Computer Science, The University of Texas at Dallas, USA</td></tr>
                        <tr><td>Luca Davoli, University of Parma, Italy</td></tr>
                        <tr><td>Luiz Bittencourt, University of Campinas, Brazil</td></tr>
                        <tr><td>Madhusudhan Govindaraju, Binghamton University, USA</td></tr>
                        <tr><td>Marco Guazzone, University of Piemonte Orientale, Italy</td></tr>
                        <tr><td>Maria Carla Calzarossa, University of Pavia, Italy</td></tr>
                        <tr><td>Martin Jacobsson, KTH Royal Institute of Technology, Sweden</td></tr>
                        <tr><td>Muhammad Zakarya, Sohar University, Oman</td></tr>
                        <tr><td>Nadia Zeghib, University Constantine 2, Algeria</td></tr>
                        <tr><td>Nikos Parlavantzas, Research Institute Computer And Systems Aléatoires, France</td></tr>
                        <tr><td>Nitin Auluck, Indian Institute of Technology Ropar, India</td></tr>
                        <tr><td>Olivia Das, Toronto Metropolitan University, Canada</td></tr>
                        <tr><td>Philipp Gschwandtner, University of Innsbruck, Austria</td></tr>
                        <tr><td>Prasad Calyam, University of Missouri Columbia, USA</td></tr>
                        <tr><td>Priyanthi Dassanayake, University of Leicester, UK</td></tr>
                        <tr><td>Qiang Guan, Kent State University</td></tr>
                        <tr><td>Radu Prodan, University of Klagenfurt, Austria</td></tr>
                        <tr><td>Rajkumar Buyya, The University of Melbourne, Australia</td></tr>
                        <tr><td>Ramin Yahyapour, University of Göttingen, Germany</td></tr>
                        <tr><td>Rui Han, Beijing Institute of Technology, China</td></tr>
                        <tr><td>Ryan Grant, Queen's University, Canada</td></tr>
                        <tr><td>Sangmi Pallickara, Colorado State University, USA</td></tr>
                        <tr><td>Schahram Dustar, Vienna University of Technology, Austria</td></tr>
                        <tr><td>Shadi Ibrahim, Inria Rennes, France</td></tr>
                        <tr><td>Shrideep Pallickara, Colorado State University, USA</td></tr>
                        <tr><td>Simon Caton, University College Dublin, Ireland</td></tr>
                        <tr><td>Sukhpal Singh Gill, Queen Mary University of London, United Kingdom</td></tr>
                        <tr><td>Thomas Fahringer, UIBK, Austria</td></tr>
                        <tr><td>Toshihiro Hanawa, The University of Tokyo, Japan</td></tr>
                        <tr><td>Valeria Cardellini, University of Roma "Tor Vergata", Italy</td></tr>
                        <tr><td>Vasilios Andrikopoulos, University of Groningen, Netherland</td></tr>
                        <tr><td>Vincenzo De Maio, Technische Universität Wien, Austria</td></tr>
                        <tr><td>Vladimir Vlassov, KTH Royal Institute of Technology, Sweden</td></tr>
                        <tr><td>Weilong Ding, North China University of Technology, China</td></tr>
                        <tr><td>Xiaoyi Lu, University of California, USA</td></tr>
                        <tr><td>Yao Liu, Rutgers University, USA</td></tr>
                        <tr><td>Yogesh Barve, Vanderbilt University, USA</td></tr>
                        <tr><td>Yong Chen, Texas Tech University, USA</td></tr>
                        <tr><td>Youseef	Alotaibi, Umm Al-Qura University, Arabia Saudita</td></tr>
                        <tr><td>Zhi Qiao, Microsoft</td></tr>
                        </tbody>
                </table>
            </Content>
        </PageWrapper>
    );
};

export default SteeringCommittee;
